export enum CouponTypeEnum {
  ADVOCACY = 0,
  RECURRENCE = 1,
  EXPERIENTIAL = 2,
  CUSTOM = 3,
  DISCOVERY = 4,
}

export enum CouponStateEnum {
  EXPIRED = 0,
  CONSUMED = 1,
  VALID = 2,
  INVALID = 3,
}

export enum ConsumableNatureEnum {
  PROMO = 3,
  POST = 4,
  PRODUCT = 8,
  PRODUCT_SAP = 9,
  DI = 10,
  DI_SAP = 11,
  MINI = 12,
  MINI_SAP = 13,
}

export enum ConsumablePointsOperatorEnum {
  EQUAL = 0,
  ADD = 1,
  MULTIPLY = 2,
  DIVIDE = 3,
  PERCENT = 4,
}

export enum CampaignTypes {
  GENERAL = 0,
  BLACK_FRIDAY = 1,
  GENERAL_AI = 2,
  BLACK_FRIDAY_AI = 3,
}
